import React from 'react';

import {
  FaBaby,
  FaBookOpen,
  FaBriefcase,
  FaBuilding,
  FaCalendarAlt,
  FaCat,
  FaChartLine,
  FaFilm,
  FaFlag,
  FaGraduationCap,
  FaHandRock,
  FaHeart,
  FaHome,
  FaIndustry,
  FaMapMarkerAlt,
  FaMusic,
  FaPlane,
  FaRunning,
  FaStar,
  FaTrophy,
  FaUserTie,
  FaVenus,
  FaVenusMars,
} from 'react-icons/fa';
import {
  GiCrown,
  GiFilmSpool,
  GiGamepadCross,
  GiLightBulb,
  GiRocketFlight,
  GiScales,
  GiTheater,
} from 'react-icons/gi';
import { IoPerson } from 'react-icons/io5';
import { MdMic, MdPsychology } from 'react-icons/md';
import { TbDog } from 'react-icons/tb';

import { Apartment } from '@mui/icons-material';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import GroupsIcon from '@mui/icons-material/Groups';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import StarIcon from '@mui/icons-material/Star';
import StarsIcon from '@mui/icons-material/Stars';

export const categoryIconMapping: Record<string, React.ReactNode> = {
  // Categorias principais baseadas nos nomes da API
  perfil_pessoal_familiar: React.createElement(PersonIcon),
  preferencias_pessoais: React.createElement(StarIcon),
  perfil_profissional_carreira: React.createElement(BusinessCenterIcon),
  perfil_empresarial_negocios: React.createElement(Apartment),
  preferencias_profissionais: React.createElement(StarsIcon),
  desafios_proposito_legado: React.createElement(EmojiEventsIcon),
  localidade_chave: React.createElement(LocationOnIcon),
  desafios_empresa_2025: React.createElement(EmojiEventsIcon),
  desafios_area_comercial: React.createElement(QueryStatsIcon),
  biografia: React.createElement(BusinessCenterIcon),

  // Preferências Pessoais
  hobbies: React.createElement(GiGamepadCross),
  musicas: React.createElement(FaMusic),
  filmes: React.createElement(FaFilm),
  pets: React.createElement(FaCat),
  literatura: React.createElement(FaBookOpen),

  // Preferências Profissionais
  temas: React.createElement(FaStar),
  leitura: React.createElement(FaBookOpen),
  conexoes: React.createElement(GroupsIcon),

  // Desafios e Propósito
  profissional: React.createElement(PersonIcon),
  pessoal: React.createElement(PersonIcon),
  prioridades: React.createElement(FaFlag),
  causas: React.createElement(FaTrophy),
  legado: React.createElement(FaFlag),

  // Perfil Profissional e Carreira
  formacao: React.createElement(FaGraduationCap),
  profissao: React.createElement(FaBriefcase),
  posicao: React.createElement(FaTrophy),
  carreira: React.createElement(FaCalendarAlt),

  // Perfil Empresarial
  setor: React.createElement(FaBuilding),
  ramo: React.createElement(FaIndustry),
  funcionarios: React.createElement(GroupsIcon),
  receita: React.createElement(FaChartLine),

  // Formação Acadêmica
  graduacao: React.createElement(FaGraduationCap),
  pos_graduacao: React.createElement(FaGraduationCap),
  especializacao: React.createElement(FaGraduationCap),
  mestrado: React.createElement(FaGraduationCap),
  doutorado: React.createElement(FaGraduationCap),

  // Localidade Chave
  estado_natal: React.createElement(FaHome),
  reside: React.createElement(FaMapMarkerAlt),

  // Experiência Profissional
  experiencia: React.createElement(FaBriefcase),
  cargo: React.createElement(FaUserTie),
  empresa: React.createElement(FaBuilding),

  // Perfil Pessoal e Familiar
  idade: React.createElement(FaCalendarAlt),
  estado_civil: React.createElement(FaHeart),
  genero: React.createElement(FaVenusMars),
  filhos: React.createElement(FaBaby),

  // Campos específicos baseados nos slugs da API
  agerange: React.createElement(FaCalendarAlt),
  maritalstatus: React.createElement(FaHeart),
  gender: React.createElement(FaVenusMars),
  children: React.createElement(FaBaby),

  // Campos de hobbies e preferências
  hobby: React.createElement(GiGamepadCross),
  preferencias: React.createElement(FaHeart),
  interesses: React.createElement(FaStar),

  // Campos de localização
  localidade: React.createElement(FaMapMarkerAlt),
  endereco: React.createElement(FaMapMarkerAlt),
  cidade: React.createElement(FaMapMarkerAlt),
  estado: React.createElement(FaMapMarkerAlt),

  // Campos de desafios
  desafios: React.createElement(GiLightBulb),
  proposito: React.createElement(FaFlag),
  objetivos: React.createElement(FaFlag),
};

// Mapeamento de ícones para pills/items individuais
export const pillIconMapping: Record<string, React.ReactNode> = {
  // Hobbies e Interesses
  jogos: React.createElement(GiGamepadCross),
  musica: React.createElement(FaMusic),
  filmes: React.createElement(FaFilm),
  series: React.createElement(GiFilmSpool),
  teatro: React.createElement(GiTheater),
  esportes: React.createElement(FaRunning),
  viagem: React.createElement(FaPlane),
  leitura: React.createElement(FaBookOpen),
  pets: React.createElement(FaCat),
  cachorro: React.createElement(TbDog),
  gato: React.createElement(FaCat),

  // Preferências Profissionais
  tecnologia: React.createElement(GiLightBulb),
  inovacao: React.createElement(GiRocketFlight),
  gestao: React.createElement(FaUserTie),
  estrategia: React.createElement(FaFlag),
  marketing: React.createElement(FaChartLine),
  vendas: React.createElement(FaHandRock),
  rh: React.createElement(GroupsIcon),
  financeiro: React.createElement(GiScales),
  juridico: React.createElement(GiCrown),
  compliance: React.createElement(GiScales),
  risco: React.createElement(GiScales),
  governanca: React.createElement(GiCrown),

  // Áreas de Formação
  engenharia: React.createElement(FaGraduationCap),
  administracao: React.createElement(FaGraduationCap),
  direito: React.createElement(FaGraduationCap),
  medicina: React.createElement(FaGraduationCap),
  psicologia: React.createElement(MdPsychology),
  comunicacao: React.createElement(MdMic),
  marketing_digital: React.createElement(FaChartLine),
  tecnologia_da_informacao: React.createElement(GiLightBulb),

  // Posições Profissionais
  empresario: React.createElement(FaUserTie),
  ceo: React.createElement(FaUserTie),
  diretor: React.createElement(FaUserTie),
  gerente: React.createElement(FaUserTie),
  coordenador: React.createElement(FaUserTie),
  analista: React.createElement(FaUserTie),
  consultor: React.createElement(FaUserTie),
  freelancer: React.createElement(FaUserTie),

  // Setores Empresariais
  setor_tecnologia: React.createElement(GiLightBulb),
  setor_saude: React.createElement(PersonIcon),
  setor_educacao: React.createElement(FaGraduationCap),
  setor_financeiro: React.createElement(GiScales),
  setor_varejo: React.createElement(FaBuilding),
  setor_industria: React.createElement(FaIndustry),
  setor_servicos: React.createElement(FaBuilding),
  setor_consultoria: React.createElement(FaUserTie),

  // Tempo de Carreira
  iniciante: React.createElement(FaCalendarAlt),
  junior: React.createElement(FaCalendarAlt),
  pleno: React.createElement(FaCalendarAlt),
  senior: React.createElement(FaCalendarAlt),
  especialista: React.createElement(FaUserTie),

  // Estados Civis
  solteiro: React.createElement(PersonIcon),
  casado: React.createElement(FaHeart),
  divorciado: React.createElement(PersonIcon),
  viudo: React.createElement(PersonIcon),

  // Gêneros
  masculino: React.createElement(PersonIcon),
  feminino: React.createElement(FaVenus),
  nao_binario: React.createElement(PersonIcon),

  // Faixas Etárias
  jovem: React.createElement(FaCalendarAlt),
  adulto: React.createElement(FaCalendarAlt),
  senior_idade: React.createElement(FaCalendarAlt),

  // Localidades
  brasil: React.createElement(FaMapMarkerAlt),
  sao_paulo: React.createElement(FaMapMarkerAlt),
  rio_de_janeiro: React.createElement(FaMapMarkerAlt),
  minas_gerais: React.createElement(FaMapMarkerAlt),
  parana: React.createElement(FaMapMarkerAlt),
  santa_catarina: React.createElement(FaMapMarkerAlt),
  rio_grande_do_sul: React.createElement(FaMapMarkerAlt),
  goias: React.createElement(FaMapMarkerAlt),
  distrito_federal: React.createElement(FaMapMarkerAlt),

  // Tamanhos de Empresa
  startup: React.createElement(FaBuilding),
  pequena: React.createElement(FaBuilding),
  media: React.createElement(FaBuilding),
  grande: React.createElement(FaBuilding),
  multinacional: React.createElement(FaBuilding),

  // Temas de Afinidade
  tema_tecnologia: React.createElement(GiLightBulb),
  tema_inovacao: React.createElement(GiRocketFlight),
  tema_gestao: React.createElement(FaUserTie),
  tema_estrategia: React.createElement(FaFlag),
  tema_marketing: React.createElement(FaChartLine),
  tema_vendas: React.createElement(FaHandRock),
  tema_rh: React.createElement(GroupsIcon),
  tema_financeiro: React.createElement(GiScales),
  tema_juridico: React.createElement(GiCrown),
  tema_compliance: React.createElement(GiScales),
  tema_risco: React.createElement(GiScales),
  tema_governanca: React.createElement(GiCrown),

  // Ramos de Atuação
  ramo_tecnologia: React.createElement(GiLightBulb),
  ramo_saude: React.createElement(PersonIcon),
  ramo_educacao: React.createElement(FaGraduationCap),
  ramo_financeiro: React.createElement(GiScales),
  ramo_varejo: React.createElement(FaBuilding),
  ramo_industria: React.createElement(FaIndustry),
  ramo_servicos: React.createElement(FaBuilding),
  ramo_consultoria: React.createElement(FaUserTie),
  ramo_estrategia: React.createElement(FaFlag),
  ramo_marketing: React.createElement(FaChartLine),
  ramo_vendas: React.createElement(FaHandRock),
  ramo_rh: React.createElement(GroupsIcon),
  ramo_financeiro_ramo: React.createElement(GiScales),
  ramo_juridico: React.createElement(GiCrown),
  ramo_compliance: React.createElement(GiScales),
  ramo_risco: React.createElement(GiScales),
  ramo_governanca: React.createElement(GiCrown),

  // Estilos de Música
  rock: React.createElement(FaMusic),
  pop: React.createElement(FaMusic),
  jazz: React.createElement(FaMusic),
  classica: React.createElement(FaMusic),
  eletronica: React.createElement(FaMusic),
  mpb: React.createElement(FaMusic),
  sertanejo: React.createElement(FaMusic),
  funk: React.createElement(FaMusic),
  rap: React.createElement(FaMusic),
  reggae: React.createElement(FaMusic),

  // Gêneros Literários
  ficcao: React.createElement(FaBookOpen),
  nao_ficcao: React.createElement(FaBookOpen),
  biografia: React.createElement(FaBookOpen),
  autoajuda: React.createElement(FaBookOpen),
  tecnico: React.createElement(FaBookOpen),
  romance: React.createElement(FaBookOpen),
  suspense: React.createElement(FaBookOpen),
  fantasia: React.createElement(FaBookOpen),
  scifi: React.createElement(FaBookOpen),
  policial: React.createElement(FaBookOpen),
  historico: React.createElement(FaBookOpen),
  poesia: React.createElement(FaBookOpen),
  drama: React.createElement(FaBookOpen),
  comedia: React.createElement(FaBookOpen),
  epico: React.createElement(FaBookOpen),
  aventura: React.createElement(FaBookOpen),

  // Perfil de Leitura
  tecnologia_leitura: React.createElement(GiLightBulb),
  economia_leitura: React.createElement(FaChartLine),
  politica_leitura: React.createElement(FaFlag),
  ciencia_leitura: React.createElement(GiLightBulb),
  historia_leitura: React.createElement(FaBookOpen),
  filosofia_leitura: React.createElement(FaBookOpen),
  psicologia_leitura: React.createElement(MdPsychology),
  negocios_leitura: React.createElement(FaBuilding),
  autoajuda_leitura: React.createElement(FaBookOpen),
  ficcao_leitura: React.createElement(FaBookOpen),
  nao_ficcao_leitura: React.createElement(FaBookOpen),
  biografia_leitura: React.createElement(FaBookOpen),
  tecnico_leitura: React.createElement(FaBookOpen),
  romance_leitura: React.createElement(FaBookOpen),
  suspense_leitura: React.createElement(FaBookOpen),
  fantasia_leitura: React.createElement(FaBookOpen),
  scifi_leitura: React.createElement(FaBookOpen),
  policial_leitura: React.createElement(FaBookOpen),
  historico_leitura: React.createElement(FaBookOpen),
  poesia_leitura: React.createElement(FaBookOpen),
  drama_leitura: React.createElement(FaBookOpen),
  comedia_leitura: React.createElement(FaBookOpen),
  epico_leitura: React.createElement(FaBookOpen),
  aventura_leitura: React.createElement(FaBookOpen),

  // Formas de Aperfeiçoamento
  cursos_online: React.createElement(FaGraduationCap),
  workshops: React.createElement(FaGraduationCap),
  certificacoes: React.createElement(FaGraduationCap),
  mentoria: React.createElement(FaUserTie),
  networking: React.createElement(GroupsIcon),
  conferencias: React.createElement(MdMic),
  meetups: React.createElement(GroupsIcon),
  eventos_sociais: React.createElement(GroupsIcon),
  viagens_negocios: React.createElement(FaPlane),
  leitura_livros: React.createElement(FaBookOpen),
  podcasts: React.createElement(MdMic),
  youtube: React.createElement(PersonIcon),
  linkedin: React.createElement(GroupsIcon),
  grupos_whatsapp: React.createElement(GroupsIcon),
  comunidades_online: React.createElement(GroupsIcon),
  hackathons: React.createElement(GiLightBulb),
  competicoes: React.createElement(FaTrophy),
  voluntariado: React.createElement(FaHeart),
  projetos_pessoais: React.createElement(PersonIcon),
  colaboracoes: React.createElement(GroupsIcon),
  parcerias: React.createElement(FaHandRock),
  aceleradoras: React.createElement(GiRocketFlight),
  incubadoras: React.createElement(FaBuilding),
  coworking: React.createElement(FaBuilding),
  assinaturas: React.createElement(FaStar),
  coaching: React.createElement(FaUserTie),
  terapia: React.createElement(MdPsychology),
  meditacao: React.createElement(PersonIcon),
  exercicios: React.createElement(FaRunning),
  yoga: React.createElement(PersonIcon),
  artes: React.createElement(PersonIcon),
  musica_hobby: React.createElement(FaMusic),
  culinaria: React.createElement(PersonIcon),
  jardinagem: React.createElement(PersonIcon),
  fotografia: React.createElement(PersonIcon),
  pintura: React.createElement(PersonIcon),
  escultura: React.createElement(PersonIcon),
  dança: React.createElement(PersonIcon),
  teatro_hobby: React.createElement(GiTheater),
  cinema: React.createElement(FaFilm),
  literatura_hobby: React.createElement(FaBookOpen),
  poesia_hobby: React.createElement(FaBookOpen),
  blog: React.createElement(PersonIcon),
  vlog: React.createElement(PersonIcon),
  podcast_hobby: React.createElement(MdMic),
  radio: React.createElement(MdMic),
  tv: React.createElement(PersonIcon),
  streaming: React.createElement(FaFilm),
  jogos_eletronicos: React.createElement(GiGamepadCross),
  jogos_tabuleiro: React.createElement(GiGamepadCross),
  quebra_cabecas: React.createElement(GiGamepadCross),
  xadrez: React.createElement(GiGamepadCross),
  poker: React.createElement(GiGamepadCross),
  outros_jogos: React.createElement(GiGamepadCross),
  colecionismo: React.createElement(PersonIcon),
  modelagem: React.createElement(PersonIcon),
  maquetes: React.createElement(PersonIcon),
  lego: React.createElement(PersonIcon),
  origami: React.createElement(PersonIcon),
  tricot: React.createElement(PersonIcon),
  croche: React.createElement(PersonIcon),
  costura: React.createElement(PersonIcon),
  bordado: React.createElement(PersonIcon),
  outros_hobbies: React.createElement(PersonIcon),
};

// Categorias que devem usar ContentPill
export const PILL_CATEGORIES = [
  'hobbies',
  'musicas',
  'filmes',
  'pets',
  'literatura',
  'temas',
  'leitura',
  'conexoes',
  'formas_aperfeicoamento',
  'estilos_musica',
  'generos_literarios',
  'perfil_leitura',
];

// Categorias que devem usar InfoCard
export const INFO_CARD_CATEGORIES = [
  'profissional',
  'pessoal',
  'prioridades',
  'causas',
  'legado',
  'formacao',
  'profissao',
  'posicao',
  'carreira',
  'setor',
  'ramo',
  'funcionarios',
  'receita',
  'graduacao',
  'pos_graduacao',
  'especializacao',
  'mestrado',
  'doutorado',
  'estado_natal',
  'reside',
  'experiencia',
  'cargo',
  'empresa',
  'idade',
  'estado_civil',
  'genero',
  'filhos',
];

// Função para obter ícone de categoria
export const getCategoryIcon = (category: string): React.ReactNode => {
  const normalizedCategory = category.toLowerCase().replace(/\s+/g, '_');
  return categoryIconMapping[normalizedCategory] || React.createElement(IoPerson);
};

// Função para obter ícone de pill/item
export const getPillIcon = (pill: string): React.ReactNode => {
  const normalizedPill = pill.toLowerCase().replace(/\s+/g, '_');
  return pillIconMapping[normalizedPill] || React.createElement(IoPerson);
};

// Função para determinar se deve usar ContentPill
export const shouldUsePills = (category: string): boolean => {
  const normalizedCategory = category.toLowerCase().replace(/\s+/g, '_');
  return PILL_CATEGORIES.includes(normalizedCategory);
};

// Função para determinar se deve usar InfoCard
export const shouldUseInfoCard = (category: string): boolean => {
  const normalizedCategory = category.toLowerCase().replace(/\s+/g, '_');
  return INFO_CARD_CATEGORIES.includes(normalizedCategory);
};
